module.exports = __webpack_public_path__ + "img/Gruppenführer_B_2.cfef42d4.svg";